export class StopEnrolling {
    studentId: string;
    courseId: string;
    reason: string;
    comment: string;
}  